import React from 'react';

export function Select({ value, onValueChange, children, placeholder }) {
  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded-md bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-400 cursor-pointer"
      >
        {/* Placeholder Option */}
        <option value="" disabled hidden>{placeholder}</option>
        
        {React.Children.map(children, (child) => {
          if (child.type === SelectItem) {
            return React.cloneElement(child, { key: child.props.value });
          }
          return child;
        })}
      </select>
    </div>
  );
}

export function SelectItem({ value, children }) {
  return <option value={value}>{children}</option>;
}

